import { render, staticRenderFns } from "./ShiftSalePopup.vue?vue&type=template&id=67f58be3&"
import script from "./ShiftSalePopup.vue?vue&type=script&lang=js&"
export * from "./ShiftSalePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports